/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketGoogleStoreProductListListData model module.
 * @module model/MarketGoogleStoreProductListListData
 * @version 1.0
 */
class MarketGoogleStoreProductListListData {
    /**
     * Constructs a new <code>MarketGoogleStoreProductListListData</code>.
     * @alias module:model/MarketGoogleStoreProductListListData
     */
    constructor() { 
        
        MarketGoogleStoreProductListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketGoogleStoreProductListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketGoogleStoreProductListListData} obj Optional instance to populate.
     * @return {module:model/MarketGoogleStoreProductListListData} The populated <code>MarketGoogleStoreProductListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketGoogleStoreProductListListData();

            if (data.hasOwnProperty('productNo')) {
                obj['productNo'] = ApiClient.convertToType(data['productNo'], 'Number');
            }
            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'String');
            }
            if (data.hasOwnProperty('productName')) {
                obj['productName'] = ApiClient.convertToType(data['productName'], 'String');
            }
            if (data.hasOwnProperty('productType')) {
                obj['productType'] = ApiClient.convertToType(data['productType'], 'String');
            }
            if (data.hasOwnProperty('itemList')) {
                obj['itemList'] = ApiClient.convertToType(data['itemList'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Boolean');
            }
            if (data.hasOwnProperty('typeCode')) {
                obj['typeCode'] = ApiClient.convertToType(data['typeCode'], 'Number');
            }
            if (data.hasOwnProperty('limitType')) {
                obj['limitType'] = ApiClient.convertToType(data['limitType'], 'Number');
            }
            if (data.hasOwnProperty('purchaseLimit')) {
                obj['purchaseLimit'] = ApiClient.convertToType(data['purchaseLimit'], 'Number');
            }
            if (data.hasOwnProperty('saleLimit')) {
                obj['saleLimit'] = ApiClient.convertToType(data['saleLimit'], 'Number');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketGoogleStoreProductListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketGoogleStoreProductListListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['productId'] && !(typeof data['productId'] === 'string' || data['productId'] instanceof String)) {
            throw new Error("Expected the field `productId` to be a primitive type in the JSON string but got " + data['productId']);
        }
        // ensure the json data is a string
        if (data['productName'] && !(typeof data['productName'] === 'string' || data['productName'] instanceof String)) {
            throw new Error("Expected the field `productName` to be a primitive type in the JSON string but got " + data['productName']);
        }
        // ensure the json data is a string
        if (data['productType'] && !(typeof data['productType'] === 'string' || data['productType'] instanceof String)) {
            throw new Error("Expected the field `productType` to be a primitive type in the JSON string but got " + data['productType']);
        }
        // ensure the json data is a string
        if (data['itemList'] && !(typeof data['itemList'] === 'string' || data['itemList'] instanceof String)) {
            throw new Error("Expected the field `itemList` to be a primitive type in the JSON string but got " + data['itemList']);
        }

        return true;
    }


}



/**
 * @member {Number} productNo
 */
MarketGoogleStoreProductListListData.prototype['productNo'] = undefined;

/**
 * @member {String} productId
 */
MarketGoogleStoreProductListListData.prototype['productId'] = undefined;

/**
 * @member {String} productName
 */
MarketGoogleStoreProductListListData.prototype['productName'] = undefined;

/**
 * @member {String} productType
 */
MarketGoogleStoreProductListListData.prototype['productType'] = undefined;

/**
 * @member {String} itemList
 */
MarketGoogleStoreProductListListData.prototype['itemList'] = undefined;

/**
 * @member {Boolean} status
 */
MarketGoogleStoreProductListListData.prototype['status'] = undefined;

/**
 * @member {Number} typeCode
 */
MarketGoogleStoreProductListListData.prototype['typeCode'] = undefined;

/**
 * @member {Number} limitType
 */
MarketGoogleStoreProductListListData.prototype['limitType'] = undefined;

/**
 * @member {Number} purchaseLimit
 */
MarketGoogleStoreProductListListData.prototype['purchaseLimit'] = undefined;

/**
 * @member {Number} saleLimit
 */
MarketGoogleStoreProductListListData.prototype['saleLimit'] = undefined;

/**
 * @member {Date} startedAt
 */
MarketGoogleStoreProductListListData.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
MarketGoogleStoreProductListListData.prototype['endedAt'] = undefined;

/**
 * @member {Date} createdAt
 */
MarketGoogleStoreProductListListData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
MarketGoogleStoreProductListListData.prototype['updatedAt'] = undefined;






export default MarketGoogleStoreProductListListData;

